<template>
  <div :class="{ 'h-full': showMobileView }">
    <!-- The mobile experience owns the full viewport height; without h-full the
         MobileConversationsView h-full chain collapses to content height and the
         composer floats up. Desktop keeps its auto height. -->
    <MobileConversationsView v-if="showMobileView" />
    <ConversationsComponent v-else />
  </div>
</template>

<script setup lang="ts">
import ConversationsComponent from '@/views/conversations/conversations.vue';
import MobileConversationsView from '@/components/Mobile/MobileConversationsView.vue';
import { useJobsRouting } from '@/composables/jobs/useJobsRouting';
import { useShowMobileView } from '@/composables/useShowMobileView';
import MeService from '@/core/shared/me/me.service';

// Resolve the injection-bound gate before the async await below; after an await
// the setup instance context is gone and inject() (used by useDisplay) no longer works.
const showMobileView = useShowMobileView();

const meService = new MeService();

// Fix auth race condition by ensuring employer is loaded before routing logic
// This works because the parent component (layouts/jobs.vue) wraps this component
// in a <Suspense> boundary. Vue 3's Suspense will wait for this async setup to
// complete before rendering, ensuring authentication is ready before any routing
// logic or API calls are made.
if (!meService.employer?.id) {
  await meService.fetchAndSetEmployer();
}

// All complex routing logic is now handled by the composable. It drives both the
// desktop panes and the mobile wrapper; neither path refactors the other. On phones
// the gate suppresses the auto-redirect to the first conversation so the Activity
// inbox is the landing screen.
useJobsRouting({ disableAutoRedirect: showMobileView });
</script>
